<template>
    <section>
    <AddCampaignPeopleModal>
    </AddCampaignPeopleModal>
    <JoinTeamVolunteerModal
        :person="personDetails"
    ></JoinTeamVolunteerModal>
    <TeamVolunteerProfileModal
        :person="personDetails"
    ></TeamVolunteerProfileModal>
    <RemoveMemberCampaignModal
        :person="personDetails"
    ></RemoveMemberCampaignModal>
    <Header 
        :header_page_data="headerPageData"
    ></Header>
      <section>
        <div v-if="isOwner(this.$store.getters['currentCampaign'].owner_id)" class="container container-app">
            <section class="position-relative campaigns-container mt-5 mb5">
                <div class="people-scroll-container">
                    <div v-for="(person, index) in teamsList" class="row mb-2" :key="index">
                        <div v-if="!isOwner(person._id)" class="col-2">
                            <div class="round-person-name" :style="'background: ' + listDesignColor[calculateColorListing(index)].background + ';  border: 2px solid #ffffff; box-shadow: 0 0 0 2px ' + listDesignColor[calculateColorListing(index)].border + ';'"><span :style="'color: ' + listDesignColor[calculateColorListing(index)].color + ';'">{{ person.name.substring(0,1).toUpperCase() }}</span></div>
                        </div>
                        <div v-if="!isOwner(person._id)"  class="col-5 mt-3 pl-0">
                            <div @click.prevent="showPersonDetails(person)" class="person-name ml-3 float-left cursor-pointer">{{ person.name }}</div>
                        </div>
                        <div v-if="!isOwner(person._id)" class="col-5 mt-3">
                            <!-- <img @click.prevent="showPersonDetails(person)" class="float-right info-icon mr-3 cursor-pointer" src="./../../assets/info.svg" alt="info" /> -->
                            <div v-if="person.user_status == 'pending' || person.user_status == 'denied'" class="campaign-status float-right mr-2" :class="person.user_status">{{ $t('campaign_teams.status.'+person.user_status) }}</div>
                        </div>
                    </div>
                </div>
            </section>
             <div class="add-persons">
                <img v-if="isOwner($store.getters['currentCampaign'].owner_id)" @click.prevent="addPeople()" src="./../../assets/add.svg" alt="add">
            </div>
        </div>
        <div v-else class="container container-app">
            <span class="not-allowed-label w-100 text-center d-block mt-5">{{ $t('campaign_teams.not_allowed') }}</span>
        </div>
      </section>
    <CampaignFooter></CampaignFooter>
    </section>
</template>

<script>
    import Header from "../layouts/Header";
    import CampaignFooter from "../layouts/CampaignFooter";
    import HelperMixin from "../../mixins/HelperMixin";
    import TeamVolunteerProfileModal from "../modals/TeamVolunteerProfileModal";
    import JoinTeamVolunteerModal from "../modals/JoinTeamVolunteerModal";
    import RemoveMemberCampaignModal from "../modals/RemoveMemberCampaignModal";
    import AddCampaignPeopleModal from "../modals/AddCampaignPeopleModal";
    

    export default {
        name: "CampaignTeams",
        components: {Header, CampaignFooter, TeamVolunteerProfileModal, JoinTeamVolunteerModal, RemoveMemberCampaignModal, AddCampaignPeopleModal},
        mixins: [HelperMixin],
        data() {
            return {
                personDetails: {},
                teamsList: [
                ],
                headerPageData: {
                    title: this.$store.getters["currentCampaign"].name,
                    search: {
                        show: false,
                        type_search: 'campaign_teams'
                    },
                    settings: {
                        show: true,
                        campaign: this.$store.getters["currentCampaign"]
                    },
                    home: {
                        show: true,
                        goto: 'campaign-map'
                    },
                    profile: {
                        show: false
                    }
                },
            }
        },
        created() {
            this.refreshData();
            this.getPeopleCampaign();
        },
        computed: {
            
        },
        methods: {
            refreshTeamsData() {
                if (this.$store.getters["user"] === null) {
                    if (typeof this.$store.getters["token"] == 'undefined') {
                         this.$router.replace({ name: "login"});
                    }
                    this.refreshData();
                }
            },

            getPeopleCampaign() {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                
                axios.post(
                        '/api/v1/campaign/'  +  this.$route.params.campaign_id +  '/user/get',
                        {},
                        config
                ).then(this.consumegetPeopleCampaign, this.errorgetPeopleCampaign);
            },

            consumegetPeopleCampaign: function (response) {
                this.teamsList = response.data.data;
                
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },

            errorgetPeopleCampaign: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                console.log(error);
            },

            addPeople() {
                $('#addCampaignPeopleModal').modal('show');
            },

           showPersonDetails(person) {
                this.personDetails = person;
                if (person.user_status == 'pending') {
                    $('#joinTeamVolunteerModal').modal('show')
                } else {
                    $('#teamVolunteerProfileModal').modal('show')
                }
            },
        },
    };
</script>
